var map = {
	"./avatar": 17,
	"./avatar.png": 17,
	"./favicon": 18,
	"./favicon.png": 18,
	"./login-bg": 19,
	"./login-bg.jpg": 19,
	"./logo": 20,
	"./logo.png": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;